import WorkCrewsIndex from "@/WorkCrews/WorkCrewsIndex.vue";

export default [
  {
    path: "/departments/:id/work_crews",
    name: "WorkCrewsIndex",
    component: WorkCrewsIndex,
    meta: {
      permissionRoles: ["user_settings"]
    }
  }
];
